import React from 'react';
import styled from 'styled-components';
import {actionType, riskTypes} from '../../../../../../../util/uiconstants';
import {IconoirArrowDown, IconoirArrowUp} from '@ey-xd/motif-icon';
import Icon from '../../../../../../Common/BaseComponentWrappers/MotifIcon';
import {labels} from '../../../../../../../util/utils';

export default function InherentRiskTypeCellRenderer(params) {
	const data = params.data;
	const inherentRiskFactorTypeId = params.typeId;
	const selectedActions = params.selectedActions;
	const relatedDocument = params.data.relatedDocId;
	const selectedRisks = params.selectedRisks;
	const level = params.node.level;

	const categoryOrLevel = {higher: '1', lower: '2'};

	let documentRisks = selectedRisks.filter((risk) => risk.documentId === relatedDocument);
	let relevantRisks = [];

	const inherentRiskFactorType = selectedActions.filter(
		(action) =>
			action.documentId === relatedDocument &&
			Number(action.customProperty1) === inherentRiskFactorTypeId &&
			action.actionTypeId === actionType.InherentRiskCategoryAndLevel
	);
	const showSomethingInThisColumn =
		level !== 0 || selectedActions.some((action) => action.documentId === relatedDocument);

	const higherOrHasAtLeastOneFRSRAssociatedToResponse = () => {
		const higher = inherentRiskFactorType.some((irft) => irft.customProperty2 === categoryOrLevel['higher']);
		if (higher) {
			return true;
		} else {
			if (documentRisks.length > 0) {
				let found = documentRisks.filter(
					(risk) => risk.riskTypeId === riskTypes.SIGNIFICANTRISK || risk.riskTypeId === riskTypes.FRAUDRISK
				);
				if (found) {
					/*found the risk, now check if it is in the current column*/
					let showHigher = found.find((risk) => {
						return inherentRiskFactorType.some((irft) => irft.formBodyOptionId === risk.formBodyOptionId);
					});
					return showHigher;
				}
				return false;
			} else {
				return false;
			}
		}
	};

	const showSomethingForLevel1 = () => {
		if (inherentRiskFactorType.length > 0) {
			if (higherOrHasAtLeastOneFRSRAssociatedToResponse()) {
				return (
					<StyledInherentRiskFactor className="StyledInherentRiskFactor">
						<section className="RisksTypesContainer">
							<span className="risk high-risk">
								<Icon src={IconoirArrowUp} />
							</span>
						</section>
					</StyledInherentRiskFactor>
				);
			} else if (inherentRiskFactorType.some((irft) => irft.customProperty2 === categoryOrLevel['lower'])) {
				return (
					<StyledInherentRiskFactor className="StyledInherentRiskFactor">
						<section className="RisksTypesContainer">
							<span className="risk low-risk">
								<Icon src={IconoirArrowDown} />
							</span>
						</section>
					</StyledInherentRiskFactor>
				);
			}
		} else {
			return <>{'-'}</>;
		}
	};
	const showSomethingForLevel2 = () => {
		if (documentRisks && documentRisks.length > 0 && inherentRiskFactorType.length > 0) {
			const hasOptionChecked = documentRisks.filter((risk) => {
				let inherentRiskFactorTypes = inherentRiskFactorType.filter(
					(irft) => Number(irft.customProperty1) === inherentRiskFactorTypeId
				);
				return inherentRiskFactorTypes.some((irft) => irft.formBodyOptionId === risk.formBodyOptionId);
			});
			if (hasOptionChecked) {
				const showCheckmark = data.assertion?.risks?.some((risk) =>
					hasOptionChecked.map((dRisk) => dRisk.riskId).includes(risk.id)
				);
				if (showCheckmark) {
					return (
						<StyledInherentRiskFactorAssertionRisk className="StyledInherentRiskFactorAssertionRisk">
							<span title={labels.associatedToInherentRiskFactor} className="associated-to-inherentRiskFactor" />
						</StyledInherentRiskFactorAssertionRisk>
					);
				}
			}
		}
	};
	const showSomethingForLevel3 = () => {
		if (documentRisks && documentRisks.length > 0) {
			relevantRisks = documentRisks.filter((risk) => risk.riskId === data.risk?.id);
			if (relevantRisks.length > 0 && inherentRiskFactorType.length > 0) {
				const showCheckmark = relevantRisks.some((risk) => {
					let inherentRiskFactorTypes = inherentRiskFactorType.filter(
						(irft) => Number(irft.customProperty1) === inherentRiskFactorTypeId
					);
					return inherentRiskFactorTypes.some((irft) => irft.formBodyOptionId === risk.formBodyOptionId);
				});
				if (showCheckmark) {
					return (
						<StyledInherentRiskFactorAssertionRisk className="StyledInherentRiskFactorAssertionRisk">
							<span title={labels.associatedToInherentRiskFactor} className="associated-to-inherentRiskFactor" />
						</StyledInherentRiskFactorAssertionRisk>
					);
				}
			}
		}
	};

	return (
		<>
			{data?.shouldShowOtherColumns !== undefined && data?.shouldShowOtherColumns === true ? (
				<>
					{showSomethingInThisColumn ? (
						<>
							{level === 0
								? showSomethingForLevel1()
								: level === 1
								? showSomethingForLevel2()
								: showSomethingForLevel3()}
						</>
					) : (
						<>{'-'}</>
					)}
				</>
			) : (
				<>{'-'}</>
			)}
		</>
	);
}

const StyledInherentRiskFactor = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: var(--px-12);
	border-top: var(--neutrals-200);
	border-radius: 0 0 var(--px-12) var(--px-12);
	background-color: transparent;
	.RisksTypesContainer {
		display: inline-flex;
		align-items: center;
		& + .RisksTypesContainer {
			margin-left: var(--px-12);
		}
	}
	.risk {
		background-color: #fff;
		color: #656579;
		border-radius: var(--px-4);
		font-size: var(--px-14);
		font-weight: 400;
		line-height: var(--px-20);
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: var(--px-28);
		height: var(--px-28);
		&.high-risk {
			border: var(--px-1) solid #b14891;
			background-color: #b14891;
			color: #fff;
			svg {
				color: #fff;
				cursor: auto;
				display: flex;
			}
		}
		&.low-risk {
			border: var(--px-2) solid #b14891;
			background: var(--neutrals-00white);
			color: var(--neutrals-1000);
			svg {
				color: var(--neutrals-1000);
				cursor: auto;
				display: flex;
			}
		}
	}
	.RiskLabel {
		font-size: var(--px-12);
		font-weight: 300;
		line-height: var(--px-16);
		color: #656579;
		margin-left: var(--px-8);
	}
`;

const StyledInherentRiskFactorAssertionRisk = styled.section`
	.associated-to-inherentRiskFactor {
		height: var(--px-10);
		width: var(--px-10);
		background-color: #656579;
		border-radius: 50%;
		display: inline-block;
	}
`;
